import { CoreCheckbox } from '@components'
import { selectMerchantCapabilities, useAppSelector } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useState } from 'react'
import ReactTooltip from 'react-tooltip'

import './trustedRecipientCheckbox.scss'

export const TrustedRecipientCheckbox = ({ formValues, trustedRecipient }) => {
  const capabilities = useAppSelector(selectMerchantCapabilities)
  const enabled = Boolean(capabilities?.trustedRecipientEnabled)

  const [checked, setChecked] = useState(!!trustedRecipient)

  const handleClick = () => {
    const newValue = !checked
    setChecked(newValue)
    if (newValue === !!trustedRecipient) {
      formValues.setValue('saveRecipientAsTrusted', '')
    } else {
      formValues.setValue('saveRecipientAsTrusted', newValue)
    }
  }

  return !enabled ? null : (
    <>
      <div className='trusted-recipient-checkbox-styled'>
        <CoreCheckbox type='check' value={'trusted-recipient'} checked={checked} onClick={handleClick} />
        <div>{tr('FRONTEND.WITHDRAWAL.TRUST_RECIPIENT', 'Trust this recipient')}</div>
        <div
          className='info'
          data-for='info-tooltip'
          data-tip={tr(
            'FRONTEND.WITHDRAWAL.TRUST_RECIPIENT_INFO',
            'Do not ask for 2FA code for subsequent transfers to this recipient'
          )}
        />
      </div>

      <ReactTooltip id='info-tooltip' place='top' type='dark' effect='solid' html={false} />
    </>
  )
}
